import { apiService } from './api';

export interface Employee {
  id: number;
  employeeCode: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email?: string;
  phone?: string;
  jobTitle?: string;
  departmentId?: number | null;
  departmentName?: string | null;
  userId?: number | null;
  hireDate: string;
  terminationDate?: string | null;
  isActive: boolean;
}

export interface CreateEmployeeDTO {
  employeeCode: string;
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  jobTitle?: string;
  departmentId?: number | null;
  userId?: number | null;
  hireDate: string;
  isActive: boolean;
}

export interface UpdateEmployeeDTO extends CreateEmployeeDTO {
  terminationDate?: string | null;
}

/**
 * HR is a standalone app (AppCodes.HR) available regardless of the company's vertical,
 * so these routes sit under /hr rather than inside a module-specific path.
 */
const employeeService = {
  getAll: async (pageNumber = 1, pageSize = 100) => {
    const response = await apiService.get<Employee[]>('/hr/employees', { pageNumber, pageSize });
    return {
      items: response.data.data ?? [],
      pagination: response.data.pagination,
    };
  },

  getById: async (id: number) => {
    const response = await apiService.get<Employee>(`/hr/employees/${id}`);
    return response.data.data;
  },

  create: async (dto: CreateEmployeeDTO) => {
    const response = await apiService.post<Employee>('/hr/employees', dto);
    return response.data.data;
  },

  update: async (id: number, dto: UpdateEmployeeDTO) => {
    const response = await apiService.put<Employee>(`/hr/employees/${id}`, dto);
    return response.data.data;
  },

  delete: (id: number) => apiService.delete(`/hr/employees/${id}`),
};

export default employeeService;
